<template>
  <section>
    <section class="ranking-popup-wrapper">
      <div
        class="close-wrapper"
        @click="showSwitch"
        :style="{ background: 'rgba(0,0,0,0)' }"
        v-if="showPopup && !rulePopupIsOpen"
      >
        <span class="iconfont icon-cancel"></span>
      </div>
      <van-popup
        v-model="showPopup"
        position="bottom"
        :style="{ height: '90%' }"
        round
        class="ranking-popup"
        :close-on-click-overlay="false"
      >
        <RankingHome
          type="popup"
          @clickPopup="clickPopup"
          @openRulePopup="openRulePopup"
        />
      </van-popup>
    </section>
    <move-animation v-if="showActivityEntrance" :initY="120">
      <img v-lazy="entrancePic" class="floatEntryImage" @click="openPopup" />
    </move-animation>
  </section>
</template>
<script>
  import RankingHome from './index.vue'
  import { mapState } from 'vuex'
  import { getAcitivityInfo, uvidIsOdd } from '../helper'
  import MoveAnimation from '@/components/MoveAnimation'
  import { pagePopupShow, pagePopupClick } from '@/pages/marketingFirebase.js'

  export default {
    components: {
      RankingHome,
      MoveAnimation,
    },
    props: {
      gameName: {
        default: '',
        type: String,
      },
    },
    data() {
      return {
        showPopup: false,
        activityInfos: {},
        entrancePic: '',
        uvidIsOdd: uvidIsOdd(),
        showActivityEntrance: false,
        rulePopupIsOpen: false,
      }
    },
    computed: {
      ...mapState(['region', 'userInfo', 'isApp']),
      loginStatus() {
        const { kicoinId, kicoinToken } = this.userInfo || {}
        if (kicoinId && kicoinToken) {
          return true
        }
        return false
      },
    },
    watch: {
      showPopup(val) {
        if (val) {
          const { activityInfos = {} } = this
          pagePopupShow({
            page: this.gameName || 'home',
            popup_type: 'popup',
            act_id: activityInfos.activityId || '',
          })
        }
      },
      showActivityEntrance(val) {
        if (val) {
          const { activityInfos = {} } = this
          pagePopupShow({
            page: this.gameName || 'home',
            popup_type: 'toast',
            act_id: activityInfos.activityId || '',
          })
        }
      },
      loginStatus: {
        handler(val) {
          val && this.getRankingAcitivityInfo()
        },
        immediate: true,
      },
    },
    mounted() {},
    methods: {
      getRankingAcitivityInfo() {
        getAcitivityInfo().then((res) => {
          const { extraInfo, game = '', activityStatus = 0 } = res || {}
          this.activityInfos = res
          const { entrancePic = '' } = extraInfo || {}
          this.entrancePic = entrancePic
          // 判断活动入口是否显示
          const show =
            entrancePic &&
            !this.uvidIsOdd &&
            (this.gameName === game || game.toLocaleLowerCase() === 'all') &&
            !this.isApp &&
            activityStatus * 1 === 2 && // 活动状态 1待激活 2已激活 3已停止 4已下线
            this.loginStatus

          this.showActivityEntrance = show
        })
      },
      showSwitch() {
        this.showPopup = !this.showPopup
      },
      openPopup() {
        this.showPopup = true
        const { activityInfos = {} } = this
        pagePopupClick({
          page: this.gameName || 'home',
          act_id: activityInfos.activityId || '',
        })
      },
      clickPopup() {
        this.showPopup = false
      },
      openRulePopup(flag) {
        this.rulePopupIsOpen = flag
      },
    },
  }
</script>
<style lang="scss" scoped>
  .ranking-popup-wrapper {
    .ranking-popup.van-popup {
      background-color: transparent;
    }
    .close-wrapper {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      position: fixed;
      right: 20px;
      top: 5%;
      z-index: 3000;
      .iconfont {
        color: #999;
        font-size: 100px;
      }
    }
  }
  .floatEntryImage {
    width: 600px;
    object-fit: contain;
  }
</style>
